<template>
  <div class="cons-flex">
    <div class="cons-item" :class="[courseCategoryIdFirst === item.id ? 'cur' : '', guideClass(item)]"
         v-for="item in menuList" :key="item.id"
         @click.stop="switchIdFirst(item)"
         v-track="{ functionName: `${item.name}` }"
    >
      {{ item && item.name }}
      <img v-if="courseCategoryIdFirst === item.id" src="@/assets/images/training/img(6).png" class="img-btm" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    courseCategoryIdFirst: {
      type: String,
      default: ''
    },
    courseCategoryIdSecond: {
      type: String,
      default: ''
    },
    courseCategoryIdThird: {
      type: String,
      default: ''
    }
  },
  computed: {
    guideClass() {
      return (item) => {
        switch (item.name) {
          case '基础课程':
            return 'basics-course'
          case '术式课程':
            return 'operation-course'
        }
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    switchIdFirst(item) {
      this.$emit('update:courseCategoryIdFirst', item.id)
      this.$emit('update:courseCategoryIdSecond', '')
      this.$emit('update:courseCategoryIdThird', '')
      this.$emit('defaultList')
    },
  }
}
</script>

<style scoped lang="less">
.cons-flex {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 5px 20px 0;
  box-sizing: border-box;

  .cons-item {
    width: 120px;
    position: relative;
    height: 42px;
    white-space: nowrap;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1A1A1A;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    .img-btm {
      width: 24px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0px;
    }

    &.cur {
      color: #EB1700;
      font-weight: 500;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/database/modules/DatabaseTab.vue